export const serversZoom2Data = [
  {
    id: "195.113.89.35",
    type: "default",
    dragHandle: "noDrag",
    position: { x: 325, y: 50 },
    className: "server-plain non-draggable",
    data: { label: "195.113.89.35" },
  },
  {
    id: "2001:718:1e05:604::50",
    type: "default",
    dragHandle: "noDrag",
    position: { x: 1020, y: 509 },
    className: "server-plain non-draggable",
    data: { label: "2001:718:1e05:604::50" },
  },
  {
    id: "2001:718:1e03:622::12",
    type: "default",
    dragHandle: "noDrag",
    position: { x: 160, y: 550 },
    className: "server-plain non-draggable",
    data: { label: "2001:718:1e03:622::12" },
  },
  {
    id: "195.113.76.22",
    type: "default",
    position: { x: 1020, y: 180 },
    className: "server-plain non-draggable",
    data: { label: "195.113.76.22" },
    dragHandle: "noDrag",
  },
  {
    id: "192.168.1.1",
    type: "default",
    position: { x: 390, y: 420 },
    className: "server-plain non-draggable",
    data: { label: "192.168.1.1" },
    dragHandle: "noDrag",
  },
];
